import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth/auth.service";
import { LoadingService } from "../services/loading/loading.service";
import { finalize } from "rxjs/operators";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private _auth: AuthService, private _loading: LoadingService) {}

  token = localStorage.getItem("authToken");

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this._loading.showLoading();
    const isLoginRequest = request.url.includes("/api/v1/login");
    const isForgotRequest = request.url.includes("/api/v1/forgotPassword");
    const isResetRequest = request.url.includes("/api/v1/resetPassword");
    if (!isLoginRequest && !isForgotRequest && !isResetRequest) {
      if (!this._auth.isAuthenticatedUser()) {
        // this._auth.logOut();
      }
    }
    this.token = localStorage.getItem("authToken");
    const modifiedRequest = request.clone({
      setHeaders: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${this.token}`,
      },
    });
    return next.handle(modifiedRequest).pipe(
      finalize(() => {
        this._loading.hideLoading();
      })
    );
  }
}
